( ( { hooks: { addAction: addActionBe } }, { hooks: { addAction: addActionFe } } ) => {
  // Backend Hooks
  addActionBe(
    'b3rg_btn_variation_selected',
    'b3rg/button',
    ( selectedVariation ) => {
      alert( `"${selectedVariation.title}" button variation selected.` );
    }
  );

  // Frontend Hooks
  addActionFe(
    'b3rg_btn_fe_console_log_fired',
    'b3rg/button',
    () => {
      alert( 'Console Log fired from Button\'s FrontEnd script' );
    }
  );
// eslint-disable-next-line no-undef
} )( wp, feWp );
